import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import TabConfig from './TabConfig';
import Layout from './Layout';
import useAuth from '../../../hooks/useAuth';


const Configuration = () => {
  const { user } = useAuth();
  const [configOpen, setConfigOpen] = useState(false);

  let configClass = ['menu-styler'];
  if (configOpen) {
    configClass = [...configClass, 'open'];
  }

  return (
    <React.Fragment>
      {user?.role === 'superUser' ? (
      <div id="styleSelector" className={configClass.join(' ')}>
        <div className="style-toggler">
          <Link to="#" onClick={() => setConfigOpen(!configOpen)}>
            *
          </Link>
        </div>
        <div className="style-block">
          <h5 className="mb-2">Personaliza el menú</h5>
          <hr />
          <div className="m-style-scroller">
            <Layout />
            <TabConfig />
          </div>
        </div>
      </div>
      ):("")}
    </React.Fragment>
  );
};

export default Configuration;
